export const FOOTER_MENU_COL_1 = 'footer-menu-col-1';
export const FOOTER_MENU_COL_2 = 'footer-menu-col-2';
export const MAIN_MENU = 'main-menu';
